import { createSelector } from 'reselect';
import {
  searchRequestFormatMappingSelector
} from './SearchParameter.Selectors';

const currentPageSelector = store => store.SearchField.imagesSearchResult.currentPage;
const imageSearchResultSelector = store => store.SearchField.imageSearchResult;

/* Hint: Comment out the data field if needed */
export const imageEvaluationResultSelector = createSelector(
  imageSearchResultSelector,
  ({
    url,
    width,
    height,
    insts,
    eval_results: evalResults
    // source, ext, jumboid, timestamp, batch
  }) => ({
    url,
    width,
    height,
    instanceCategories: insts ? Array.from(
      insts.reduce((accumulation, { cls_name }) => {
        accumulation.add(cls_name);
        return accumulation;
      }, new Set())
    ) : [],
    insts: insts ? insts.map(({
      bbox,
      seg,
      cls_name
      // area, sn, iscrowd, cls, sup_cls, sup_cls_name
    }) => ({ bbox, seg, cls_name })) : [],
    evalResults: evalResults || []
  })
);
export const searchImagesQuerySelector = createSelector(
  searchRequestFormatMappingSelector,
  searchFieldParameter => ({
    image_query: JSON.stringify(searchFieldParameter),
    page: 1,
    page_size: 20
  })
);

export const searchImagesNextPageQuerySelector = createSelector(
  searchRequestFormatMappingSelector,
  currentPageSelector,
  (searchFieldParameter, currentPage) => ({
    image_query: JSON.stringify(searchFieldParameter),
    page: currentPage + 1,
    page_size: 20
  })
);



// WEBPACK FOOTER //
// ./src/selectors/SearchFieldSelectors.js